import '../sass/main.scss';

// Import Resources
import '../img/defaults/gradient-background.png';


jQuery(document).ready(function ($) {

  /** Navbar */

  $('.navbar-toggler').on('click', function () {
    $('.animated-icon').toggleClass('open');
    $('.navbar').toggleClass('dark');

  });


  $('.navbar .navbar-nav .nav-item.dropdown a.nav-link').on('click', function () {
    var $el = $(this);

    location.href = $el.attr('href');
  });


  $(".dropdown").hover(
    function () {
      if ($(window).innerWidth() > 991) {
        const $this = $(this);
        $this.addClass("show");
        $this.find(".dropdown-toggle").attr("aria-expanded", "true");
        $this.find(".dropdown-menu").addClass("show");
      }
    },
    function () {
      if ($(window).innerWidth() > 991) {
        const $this = $(this);
        $this.removeClass("show");
        $this.find(".dropdown-toggle").attr("aria-expanded", "false");
        $this.find(".dropdown-menu").removeClass("show");
      }
    }
  );

  /*$(".mainpage-slogan-wrapper .slogan span.change").fadeOut(400, function () {
    $(this).html("Mobile Applications").fadeIn(400);
  });*/

  var items = ["Mobile Applications", "WordPress Themes", "Shopify Themes", "APIs", "Web Applications"];
  var $text = $('.mainpage-slogan-wrapper .slogan span.change');
  var delay = 2;

  function loopServices(delay) {
    $.each(items, function (i, elm) {
      $text.delay(delay * 1E3).fadeOut();
      $text.queue(function () {
        $text.html(items[i]);
        $text.dequeue();
      });
      $text.fadeIn();
      $text.queue(function () {
        if (i == items.length - 1) {
          loopServices(delay);
        }
        $text.dequeue();
      });
    });
  }

  loopServices(delay);


  /** Adjust CSS Functions */
  function resizePostColumnElements() {
    return false;
  }

  /** Initiate Adjust CSS Functions */
  //resizePostColumnElements();
  $(window).resize(function () {
    //resizePostColumnElements();
  });


});